/**
 * Enumeration for the road types.
 *
 * @readonly
 * @enum {string}
 */
export const RoadTypes = {
    CONNECTING_ROAD: 'CONNECTING_ROAD',
    DESTINATION_ROAD: 'DESTINATION_ROAD',
    FERRY_RAILROAD: 'FERRY_RAILROAD',
    FERRY_WATER: 'FERRY_WATER',
    LOCAL_ROAD_OF_MAJOR_IMPORTANCE: 'LOCAL_ROAD_OF_MAJOR_IMPORTANCE',
    LOCAL_ROAD: 'LOCAL_ROAD',
    MAJOR_ROAD_OF_HIGH_IMPORTANCE: 'MAJOR_ROAD_OF_HIGH_IMPORTANCE',
    MAJOR_ROAD: 'MAJOR_ROAD',
    MOTORWAY: 'MOTORWAY',
    OTHER_ROAD: 'OTHER_ROAD',
    RAILROAD: 'RAILROAD',
    REFERENCE_LINE: 'REFERENCE_LINE',
    SECONDARY_ROAD: 'SECONDARY_ROAD'
}

Object.freeze(RoadTypes)
